
import { useState, useRef, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Typography,
  Grid,
  useMediaQuery,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import websitelogo from "../assets/websitelogo.png";
import websitelogoes from "../assets/websitelogoes.png";
import CustomButton from "./CustomButton";
import featuresIcon from "../assets/featuresIcon.svg";
import { useTranslation } from "react-i18next";
import { Modal, IconButton } from "@mui/material";
import CustomText from "./CustomText";
import { useSocialLinks } from "./fetchGetAppUrl";

const Header = () => {
  const { t, i18n } = useTranslation();
  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng);
  // };
const [comingSoonOpen, setComingSoonOpen] = useState(false);

const handleOpenComingSoon = () => setComingSoonOpen(true);
const handleCloseComingSoon = () => setComingSoonOpen(false);

  const { links, loading } = useSocialLinks();


  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng).then(() => {
      window.location.reload(); // Always reload after switching
    });
    setLanguageMenuAnchor(null); // Close the dropdown
  };

  const handleLanguageMenuOpen = (event) => {
    setLanguageMenuAnchor(event.currentTarget);
  };

  const handleLanguageMenuClose = () => {
    setLanguageMenuAnchor(null);
  };

  // Language options with flags
  const languageOptions = [
    {
      code: 'en',
      name: 'English',
      // flag: '🇺🇸'
    },
    {
      code: 'es',
      name: 'Español',
      // flag: '🇪🇸'
    }
  ];

              const getCurrentLanguage = () => {
                return languageOptions.find(lang => lang.code === i18n.language) || languageOptions[0];
              };

  const navigate = useNavigate();
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const [expandedFeatureCategory, setExpandedFeatureCategory] = useState(0);
  const [languageMenuAnchor, setLanguageMenuAnchor] = useState(null);
  const timeoutRef = useRef(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setIsDropdownOpen(true);
  };
  const [loginMenuAnchor, setLoginMenuAnchor] = useState(null);

const handleLoginMenuOpen = (event) => {
  setLoginMenuAnchor(event.currentTarget);
};

const handleLoginMenuClose = () => {
  setLoginMenuAnchor(null);
};

const [getAppMenuAnchor, setGetAppMenuAnchor] = useState(null);

const handleGetAppMenuOpen = (event) => {
  setGetAppMenuAnchor(event.currentTarget);
};

const handleGetAppMenuClose = () => {
  setGetAppMenuAnchor(null);
};

const getAppLinks = {
  android: [
    { label: t("loginRoles.accountExecutive"), link: "https://play.google.com/store/apps/details?id=com.biometricproaccountexecutive1" },
    { label: t("loginRoles.companyAdmin"), link: "https://play.google.com/store/apps/details?id=com.biometricprocompanyadminapp" },
    { label: t("loginRoles.worker"), link: "https://play.google.com/store/apps/details?id=com.biometricproemployeeapp" },
  ],
  ios: [
    { label: t("loginRoles.accountExecutive"), link: "https://apps.apple.com/us/app/account-executive-biometricpro/id6752927067" },
    { label: t("loginRoles.companyAdmin"), link: "https://apps.apple.com/us/app/company-admin-biometric-pro/id6788851657" },
    { label: t("loginRoles.worker"), link: "https://apps.apple.com/us/app/employee-biometric-pro/id6790351839" },
  ],
};
  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsDropdownOpen(false);
      }, 150);
  };
  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Cleanup function to reset overflow when component unmounts
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [mobileMenuOpen]);
  const menuItems = [
    { label: t("Home"), path: "/" },
    { label: t("About"), path: "/about" },
    { label: t("Features"), path: "", icon: featuresIcon, hasDropdown: true },
    { label: t("Pricing"), path: "/pricing" },
    { label: t("Product Tour"), path: "/product-tour" },
    { label: t("Contact"), path: "/contact" },
  ];

  const featuresData = [
    {
      title: t("Clock-In/Out with Location Verification and Facial Recognition"),
      items: [
        t("Assign Tasks or Self-Assign with Clock-In/Out, Location Verification and Facial Recognition")
      ],
    },
    {
      title: t("Messaging & Conversation"),
      items: [
        t("Smart Notification System"),
        t("Employee Requests"),
        t("Documents"),
        t("Employee Reimbursements & Logs"),
      ],
    },
    {
      title: t("Employee Payroll Details & History"),
      items: [
        t("Employee and Department Productivity & Performance Report"),
        t("Employee Absence Management with Calendar View"),
        t("Employee Finances"),
        t("Employee Loan Management"),
      ],
    },
    {
      title: t("Subscription & Billing"),
      items: [
        t("Applicants Profiles \"Coming Soon\""),
        t("Vendors \"Coming Soon\""),
        t("Job Openings \"Coming Soon\""),
        t("Lender Offers \"Coming Soon\"")
      
      ],
 
    },
    {
      title: t("Account Executive"),
      items: [
        // t("Executive Dashboard \"Coming Soon\""),
        // t("Team Performance Analytics \"Coming Soon\""),
        // t("Strategic Reports \"Coming Soon\""),
        // t("Budget Management \"Coming Soon\""),
      ],
    },
  ];



  const handleViewAll = (categoryTitle) => {
    setIsDropdownOpen(false);
    // Close mobile menu if open
    if (isMobile && mobileMenuOpen) {
      setMobileMenuOpen(false);
    }

    const currentPath = location.pathname;

    // Get the English version of the title for comparison
    const englishTitle = categoryTitle === t("Clock-In/Out with Location Verification and Facial Recognition") ? "Clock-In/Out with Location Verification and Facial Recognition" :
      categoryTitle === t("Messaging & Conversation") ? "Messaging & Conversation" :
        categoryTitle === t("Employee Payroll Details & History") ? "Employee Payroll Details & History" :
          categoryTitle === t("Subscription & Billing") ? "Subscription & Billing" :
            categoryTitle === t("Account Executive") ? "Account Executive" : categoryTitle;

    switch (englishTitle) {
      case "Clock-In/Out with Location Verification and Facial Recognition":
        if (currentPath === "/time-tracking#face-recognition-validation") {
          window.history.replaceState(null, null, "/time-tracking#face-recognition-validation");
          window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => window.location.reload(), 500);
        } else {
          navigate("/time-tracking#face-recognition-validation");
        }
        break;
      case "Task Management":
        if (currentPath === "/task-management") {
          window.history.replaceState(null, null, "/task-management");
          window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => window.location.reload(), 500);
        } else {
          navigate("/task-management");
        }
        break;
      case "Messaging & Conversation":
        if (currentPath === "/communication#realtime-messaging") {
          window.history.replaceState(null, null, "/communication#realtime-messaging");
          window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => window.location.reload(), 500);
        } else {
          navigate("/communication#realtime-messaging");
        }
        break;
      case "Centralized Communication":
        if (currentPath === "/communication") {
          window.history.replaceState(null, null, "/communication");
          window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => window.location.reload(), 500);
        } else {
          navigate("/communication");
        }
        break;
      case "Financial Features":
        if (currentPath === "/financial") {
          window.history.replaceState(null, null, "/financial");
          window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => window.location.reload(), 500);
        } else {
          navigate("/financial");
        }
        break;
      case "Employee Payroll Details & History":
        if (currentPath === "/financial#finance-salary-logs") {
          window.history.replaceState(null, null, "/financial#finance-salary-logs");
          window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => window.location.reload(), 500);
        } else {
          navigate("/financial#finance-salary-logs");
        }
        break;
      case "Subscription & Billing":
        if (currentPath === "/financial#finance-payment-history") {
          window.history.replaceState(null, null, "/financial#finance-payment-history");
          window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => window.location.reload(), 500);
        } else {
          navigate("/financial#finance-payment-history");
        }
        break;
      case "Account Executive":
        if (currentPath === "/account-executive") {
          window.history.replaceState(null, null, "/account-executive");
          window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => window.location.reload(), 500);
        } else {
          navigate("/account-executive");
        }
        break;

      default:
        break;
    }
  };
  const getIdFromLabel = (label) =>
    label
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const handleFeatureItemClick = (item, categoryTitle) => {

    const comingSoonItems = [
    t("Applicants Profiles \"Coming Soon\""),
    t("Vendors \"Coming Soon\""),
    t("Job Openings \"Coming Soon\""),
    t("Lender Offers \"Coming Soon\""),
    "Applicants Profiles \"Coming Soon\"",
    "Vendors \"Coming Soon\"",
    "Job Openings \"Coming Soon\"",
    "Lender Offers \"Coming Soon\"",
  ];

  // ✅ If it's a coming soon feature, just open modal
  if (comingSoonItems.includes(item)) {
    handleOpenComingSoon();
    return;
  }

    setIsDropdownOpen(false);
    if (item === "Employee Finances" || item === t("Employee Finances")) {
      navigate("/financial#features-screen");
      return;
    }
    if (isMobile && mobileMenuOpen) {
      setMobileMenuOpen(false);
    }
    if (item === "Assign Tasks or Self-Assign with Clock-In/Out, Location Verification and Facial Recognition" || item === t("Assign Tasks or Self-Assign with Clock-In/Out, Location Verification and Facial Recognition")) {
      navigate("/task-management#card2-task");
      return;
    }

    if (item === "Smart Notification System" || item === t("Smart Notification System")) {
      navigate("/communication#communication-history");
      return;
    }


    if (item === "Employee Requests" || item === t("Employee Requests")) {
      navigate("/communication#smart-requests");
      return;
    }

    if (item === "Documents" || item === t("Documents")) {
      navigate("/communication#real-time-insight-card");
      return;
    }

    if (item === "Employee Reimbursements & Logs" || item === t("Employee Reimbursements & Logs")) {
      navigate("/financial#finance-worker-billing");
      return;
    }

    if (item === "Employee Absence Management with Calendar View" || item === t("Employee Absence Management with Calendar View")) {
      navigate("/task-management#task-map-calendar-integration");
      return;
    }


    if (item === "Employee Loan Management" || item === t("Employee Loan Management")) {
      navigate("/financial#finance-salary-payroll-logs");
      return;
    }

    if (item === "Employee and Department Productivity & Performance Report" || item === t("Employee and Department Productivity & Performance Report")) {
      navigate("/task-management#task-reporting-metrics");
      return;
    }

    const sectionId = getIdFromLabel(item);
    // const sectionId = getIdFromLabel(item?.label || item);




    if (categoryTitle === "Clock-In/Out with Location Verification and Facial Recognition") {
      let targetSectionId;
      switch (item) {
        case "Clock-In/Out with Location Verification and Facial Recognition":
          targetSectionId = "face-recognition-validation";
          break;
        default:
          targetSectionId = sectionId;
          break;
      }
      navigate(`/time-tracking#${targetSectionId}`);
    }
    else if (categoryTitle === "Task Management") {
      if (item === "Assign Tasks or Self-Assign with Clock-In/Out, Location Verification and Facial Recognition") {
        navigate("/task-management#card2-task");
        return;
      }
      let targetSectionId;
      switch (item) {
        // case "Scheduling & Tracking":
        //   targetSectionId = "task-scheduling-tracking";
        //   break;
        case "Project Assignment":
          targetSectionId = "task-scheduling-tracking";
          break;
        case "Task Creation & Assignment":
          targetSectionId = "task-biometric-validation";
          break;
        case "Calendar View":
          targetSectionId = "task-map-calendar-integration";
          break;
        case "Gantt Chart Timeline":
          targetSectionId = "task-reporting-metrics";
          break;
        case "Assign and validate tasks with confidence":
          targetSectionId = "card2-task";
          break;
        default:
          targetSectionId = `task-${sectionId}`;
          break;
      }
      navigate(`/task-management#${targetSectionId}`);
    } else if (categoryTitle === "Centralized Communication") {
      let targetSectionId;
      switch (item) {
        // case "Messaging & Conversations":
        //   targetSectionId = "realtime-messaging";
        //   break;
        case "Smart Notification System":
          targetSectionId = "communication-history";
          break;
        case "Request Generation":
          targetSectionId = "smart-requests";
          break;
        case "Admin Review & Approval":
          targetSectionId = "expense-claims";
          break;
        case "Real-time insights at your fingertips":
          targetSectionId = "real-time-insight-card";
          break;
        default:
          targetSectionId = sectionId;
          break;
      }
      navigate(`/communication#${targetSectionId}`);
    } else if (categoryTitle === "Financial Features") {
      let targetSectionId;
      switch (item) {
        //      case "Workforce & Finance Management":
        // targetSectionId = "finance-expense-system";
        // break;
        //       case "financial features":
        //  navigate("/features")
        // break;
        case "Salary Payments & Records":
          targetSectionId = "finance-expense-system";
          break;
        case "Expense Disbursement & Logs":
          targetSectionId = "finance-worker-billing";
          break;
        case "Employee Reimbursements & Logs":
          targetSectionId = "finance-worker-billing";
          break;
        case "Loan Management":
          targetSectionId = "finance-salary-payroll-logs";
          break;
        case "Worker Payment Portal & History":
          targetSectionId = "finance-salary-logs";
          break;
        case "Subscription & Billing":
          targetSectionId = "finance-payment-history";
          break;
        //   case "Real-time insights at your fingertips":
        // targetSectionId = "card3-realtime";
        // break;
        default:
          targetSectionId = `finance-${sectionId}`;
          break;

      }
      navigate(`/financial#${targetSectionId}`);
    } else {
    }
  };
const handleLoginClick = () => {
  // check if current path includes "account-executive"
  if (location.pathname.includes("/account-executive")) {
    window.open("https://account-executive.biometricpro.app", "_blank"); // ✅ new tab
  } else {
    window.open("https://company-admin.biometricpro.app", "_blank"); // ✅ new tab
  }
};
  console.log("Current i18n.language:", i18n.language);
  const heroImageSrc = i18n.language === "es" ? websitelogo : websitelogoes;
  return (
    <>
    <Box sx={{ position: "relative", width: "100%" }}>
      {/* <Box
        sx={{
          maxWidth: 1600,
          margin: "0 auto",
          // px: 2,          // horizontal padding on small screens
          display: "flex",
          alignItems: "center",
          // height: 64,     // example header height
        }}
      > */}
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: isDropdownOpen ? "#FFFFFF" : "#F8FFFF",
          boxShadow: 0,
          padding: "5px 0px",
          borderBottom: "1px solid #eee",
          transition: "background-color 0.3s ease",
          top: 0,
          zIndex: 1100,
          width: "100%",
          // backgroundColor: 'red'
        }}
      >
        <Toolbar
          sx={{
            px: { xs: 2, sm: 3, md: i18n.language === "es" ? 6 : 8 },
            display: "flex",
            justifyContent: "space-between",
            minHeight: "64px",
          }}
        >
          {/* Logo */}
          <Box sx={{ cursor: "pointer" }} onClick={() => navigate("/")}>
            <img
              src={heroImageSrc || "/placeholder.svg"}
              alt="Logo"
              style={{
                width: isMobile ? "150px" : "200px",
                height: "50px",
                objectFit: "contain",
              }}
            />
          </Box>

          {/* <div>

            <button onClick={() => changeLanguage('en')}>{t('EN')}</button>
            <button onClick={() => changeLanguage('es')}>{t('ES')}</button>
          </div> */}

          {/* Desktop Menu */}
          {!isMobile ? (
            <Box sx={{ display: "flex", gap: i18n.language === "es" ? 2 : 4 }}>
              <Box
                sx={{ display: "flex", gap: i18n.language === "es" ? 0.5 : 1 }}
              >
                {menuItems.map((item) => (
                  <div key={item.label}>
                    <Button
                      onClick={() => !item.hasDropdown && navigate(item.path)}
                      onMouseEnter={item.hasDropdown ? handleMouseEnter : null}
                      onMouseLeave={item.hasDropdown ? handleMouseLeave : null}
                      sx={{
                        color:
                          location.pathname === item.path ||
                            (item.hasDropdown && isDropdownOpen)
                            ? "primary.main"
                            : "primary.text",
                        textTransform: "none",
                        fontWeight:
                          location.pathname === item.path ||
                            (item.hasDropdown && isDropdownOpen)
                            ? 600
                            : 400,
                        fontFamily: `'Poppins', sans-serif`,
                        fontSize: i18n.language === "es" ? "14px" : "16px",
                        minWidth: "auto",
                        padding:
                          i18n.language === "es" ? "6px 8px" : "6px 12px",
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: "primary.main",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {t(item.label)}
                        {item.icon && (
                          <img
                            src={item.icon}
                            alt=""
                            style={{ width: 15, height: 15, flexShrink: 0 }}
                          />
                        )}
                      </Box>
                    </Button>
                  </div>
                ))}
              </Box>
              <Box
                sx={{ display: "flex", gap: i18n.language === "es" ? 1 : 1.5 }}
              >
                {/* <CustomButton
                  label={t("Login")}
                  variant="primary"
                  size="small"
                  sx={{
                    fontSize: "12px",
                    padding: "6px 10px !important",
                    minWidth: "auto",
                    whiteSpace: "nowrap",
                    height: "32px",
                  }}
                    onClick={handleLoginClick}

                /> */}
<CustomButton
  label={
    <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
      {t("Login")}
      <ExpandMoreIcon sx={{ fontSize: 16 }} />
    </Box>
  }
  variant="primary"
  size="small"
  onClick={handleLoginMenuOpen}
  sx={{
    fontSize: "12px",
    padding: "6px 10px !important",
    minWidth: "auto",
    whiteSpace: "nowrap",
    height: "32px",
  }}
/>

                <CustomButton
                  label={
                    <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      {t("Get App")}
                      <ExpandMoreIcon sx={{ fontSize: 16 }} />
                    </Box>
                  }
                  variant="tertiary"
                  size="small"
                  sx={{
                    fontSize: "12px",
                    padding: "6px 10px !important",
                    minWidth: "auto",
                    whiteSpace: "nowrap",
                    height: "32px",
                  }}
                    onClick={handleGetAppMenuOpen}
                />

                <Box
                  sx={{
                    // position: "absolute",
                    bottom: 20,
                    right: 30,
                    width: "fit-content",
                    // zIndex: 9999,
                  }}
                >
                  <Button
                    onClick={handleLanguageMenuOpen}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      borderRadius: "4px",
                      padding: "6px 12px",
                      cursor: "pointer",
                      backgroundColor: "#ffffff",
                      color: "#333333",
                      border: "1px solid #d1d5db",
                      textTransform: "none",
                      minWidth: "auto",
                      "&:hover": {
                        backgroundColor: "#f9fafb",
                        borderColor: "#9ca3af",
                        boxShadow: "none",
                      },
                    }}
                  >
                
                    <Typography
                      sx={{
                        color: "#333333",
                        fontWeight: 400,
                        fontSize: "12px",
                        fontFamily: `'Poppins', sans-serif`,
                      }}
                    >
                      {getCurrentLanguage().name}
                    </Typography>
                    <ExpandMoreIcon sx={{ fontSize: "16px", color: "#666666" }} />
                  </Button>

                  <Menu
                    anchorEl={languageMenuAnchor}
                    open={Boolean(languageMenuAnchor)}
                    onClose={handleLanguageMenuClose}
                    sx={{
                      "& .MuiPaper-root": {
                        borderRadius: "8px",
                        border: "1px solid #d1d5db",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                      }
                    }}
                  >
                    {languageOptions.map((language) => (
                      <MenuItem
                        key={language.code}
                        onClick={() => changeLanguage(language.code)}
                        selected={i18n.language === language.code}
                        sx={{
                          py: 1,
                          px: 2,
                          "&:hover": {
                            backgroundColor: "rgba(0, 110, 194, 0.08)",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "rgba(0, 110, 194, 0.12)",
                            "&:hover": {
                              backgroundColor: "rgba(0, 110, 194, 0.16)",
                            }
                          }
                        }}
                      >
                      
                        <ListItemText>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontFamily: `'Poppins', sans-serif`,
                              fontWeight: i18n.language === language.code ? 600 : 400,
                            }}
                          >
                            {language.name}
                          </Typography>
                        </ListItemText>
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>
              </Box>
            </Box>
          ) : (
            <Button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              sx={{ minWidth: "auto", padding: 0 }}
            >
              {mobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </Button>
          )}
        </Toolbar>
      </AppBar>
      {/* </Box> */}

      {!isMobile && (
        <Box
          sx={{
            position: "fixed",
            top: "80px", // Position right below the sticky header
            left: 0,
            right: 0,
            width: "100%",
            backgroundColor: "#FFFFFF",
            borderTop: "1px solid #E0E7FF",
            borderBottom: "1px solid #E0E7FF",
            zIndex: 1099, // Just below the header
            opacity: isDropdownOpen ? 1 : 0,
            visibility: isDropdownOpen ? "visible" : "hidden",
            transform: isDropdownOpen ? "translateY(0)" : "translateY(-10px)",
            transition:
              "opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease",
            height: isDropdownOpen ? "auto" : 0,
            overflow: "hidden",
            boxShadow: "0 8px 32px rgba(0, 110, 194, 0.15)", // Enhanced shadow with brand color
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Box
            sx={{
              width: "100%",
              padding: "60px 40px 50px 40px",
              px: { xs: 2, sm: 3, md: 6 },
              background: "linear-gradient(135deg, #FFFFFF 0%, #F8FFFF 100%)",
            }}
          >
            <Grid
              container
              sx={{
                display: "flex",
                flexWrap: "nowrap",       // 🔒 Prevents wrapping
                overflow: "hidden",       // Optional: hides spillover
              }}
              spacing={0}
            >
              {featuresData.map((category, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  key={index}
                  sx={{
                    flex: "1 1 25%", // Equal width for all 4 sections
                    maxWidth: "25%",
                    minWidth: 0,
                    borderRight:
                      index < featuresData.length - 1
                        ? "1px solid #E0E7FF"
                        : "none",
                    px: 3,
                    py: 2,
                    position: "relative",
                    "&:first-of-type": { pl: 0 },
                    "&:last-of-type": { pr: 0 },
                    "&:hover": {
                      backgroundColor: "rgba(0, 110, 194, 0.03)",
                      borderRadius: "12px",
                      transition: "all 0.3s ease",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  {/* <Grid
  item
  key={index}
  sx={{
    flex: "0 0 25%",             // 🔒 Fixed width = 25%
    maxWidth: "25%",            // 🔒 Max also 25%
    borderRight:
      index < featuresData.length - 1 ? "1px solid #EEEEEE" : "none",
    px: 2,
    "&:first-of-type": { pl: 0 },
    "&:last-of-type": { pr: 0 },
  }}
> */}
                  <Typography
                    // onClick={() => handleFeatureItemClick(category.title)}

                    onClick={() => handleViewAll(category.title)}

                    variant="body2"
                    sx={{
                      cursor: "pointer",
                      color: "#4a5568",
                      fontWeight: 400,
                      marginBottom: "20px",
                      fontSize: "14px",
                      letterSpacing: "0.3px",
                      fontFamily: `'Poppins', sans-serif`,
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      hyphens: "auto",
                      lineHeight: 1.5,
                      padding: "8px 12px",
                      borderRadius: "8px",
                      transition: "all 0.2s ease",
                      border: "1px solid transparent",
                      "&:hover": {
                        color: "#006EC2",
                        backgroundColor: "rgba(0, 110, 194, 0.08)",
                        border: "1px solid rgba(0, 110, 194, 0.2)",
                        transform: "translateX(4px)",
                        boxShadow: "0 2px 8px rgba(0, 110, 194, 0.1)"
                      }
                    }}
                  >
                    {t(category.title)}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      mt: 1
                    }}
                  >
                    {category.items.map((item, idx) => (
                      <Typography
                        key={idx}
                        onClick={() =>
                          handleFeatureItemClick(item, category.title)
                        }
                 variant="body2"
                        sx={{
                          cursor: "pointer",
                          color: "#4a5568",
                          fontWeight: 400,
                          fontSize: "14px",
                          letterSpacing: "0.3px",
                          fontFamily: `'Poppins', sans-serif`,
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          hyphens: "auto",
                          lineHeight: 1.5,
                          padding: "8px 12px",
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          border: "1px solid transparent",
                          "&:hover": {
                            color: "#006EC2",
                            backgroundColor: "rgba(0, 110, 194, 0.08)",
                            border: "1px solid rgba(0, 110, 194, 0.2)",
                            transform: "translateX(4px)",
                            boxShadow: "0 2px 8px rgba(0, 110, 194, 0.1)"
                          },
                        }}
                      >
                        {t(item)}
                      </Typography>
                    ))}
                  </Box>
                  {/* <Typography
                    variant="body2"
                    sx={{
                      mt: 2,
                      color: "primary.main",
                      cursor: "pointer",
                      fontWeight: 500,
                      fontFamily: `'Poppins', sans-serif`,
                      textDecoration: "underline",
                      letterSpacing: "-1.5%",
                      "&:hover": { opacity: 0.8 },
                    }}
                    onClick={() => handleViewAll(category.title)}
                  >
                    {" "}
                    {t("View all features")}
                  </Typography> */}
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      )}
      {isMobile && mobileMenuOpen && (
        <>
          {/* Backdrop/Overlay */}
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 999,
            }}
            onClick={() => setMobileMenuOpen(false)}
          />
          <Box
            sx={{
              position: "fixed",
              top: "80px",
              left: 0,
              right: 0,
              width: "100%",
              maxHeight: "calc(100vh - 80px)", // Adjusted for sticky header
              overflowY: "auto", // Enable scrolling if content is too long
              px: 1,
              py: 2,
              backgroundColor: "#FFFFFF",
              display: "flex",
              flexDirection: "column",
              gap: 1,
              zIndex: 1000, // Ensure it stays above other content
              borderTop: "1px solid #eee", // Optional: add a border to separate from header
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)", // Add shadow for better visual separation


            }}
          >
            {menuItems.map((item) => (
              <Box key={item.label}>
                <Button
                  onClick={() => {
                    if (item.hasDropdown) {
                      setIsMobileDropdownOpen((prev) => !prev);
                    } else {
                      navigate(item.path);
                      setMobileMenuOpen(false);
                    }
                  }}
                  sx={{
                    justifyContent: "flex-start",
                    textTransform: "none",
                    fontSize: "15px",
                    fontFamily: `'Poppins', sans-serif`,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    width: "100%",
                  }}
                >
                  {t(item.label)}
                  {item.icon && (
                    <img
                      src={item.icon}
                      alt=""
                      style={{ width: 15, height: 15 }}
                    />
                  )}
                </Button>

                {/* ✅ Mobile Mega Menu Rendering in Column */}
                {item.hasDropdown && isMobileDropdownOpen && (
                  <Box sx={{ px: 2, mt: 1 }}>
                    {featuresData.map((category, index) => (
                      <Box key={index} sx={{ mb: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            mb: 0.5,
                          }}
                        >
                          <ChevronRightIcon
                            onClick={(e) => {
                              e.stopPropagation();
                              setExpandedFeatureCategory((prev) =>
                                prev === index ? null : index
                              );
                            }}
                            sx={{
                              fontSize: "16px",
                              color: "text.primary",
                              flexShrink: 0,
                              cursor: "pointer",
                              transition: "transform 0.2s ease",
                              transform:
                                expandedFeatureCategory === index
                                  ? "rotate(90deg)"
                                  : "rotate(0deg)",
                            }}
                          />
                          <Typography
                            onClick={() => handleViewAll(category.title)}
                            sx={{
                              fontSize: "15px",
                              color: "text.primary",
                              fontFamily: `'Poppins', sans-serif`,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "220px",
                              cursor: "pointer",
                            }}
                          >
                            {t(category.title)}
                          </Typography>
                        </Box>
                        {expandedFeatureCategory === index && (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 0.5,
                              pl: "22px",
                            }}
                          >
                            {category.items.map((item, idx) => (
                              <Typography
                                key={idx}
                                onClick={() =>
                                  handleFeatureItemClick(item, category.title)
                                }

                                sx={{
                                  fontSize: "14px",
                                  fontFamily: `'Poppins', sans-serif`,
                                  color: "text.primary",
                                  cursor: "pointer",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "200px",
                                  "&:hover": { color: "primary.main" },
                                }}
                              >
                                {t(item)}
                              </Typography>
                            ))}
                          </Box>
                        )}
                        {/* <Typography
                          sx={{
                            mt: 1,
                            color: "primary.main",
                            cursor: "pointer",
                            fontSize: "14px",
                            textDecoration: "underline",
                            fontFamily: `'Poppins', sans-serif`,
                            "&:hover": { opacity: 0.8 },
                          }}
                          onClick={() => {
                            handleViewAll(category.title);
                            setMobileMenuOpen(false);
                          }}
                        >
                          {t("View all features")}
                        </Typography> */}
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            ))}
            <CustomButton
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  {t("Login")}
                  <ExpandMoreIcon sx={{ fontSize: 16 }} />
                </Box>
              }
              variant="primary"
              size="small"
              sx={{
                fontSize: "12px",
                padding: "6px 10px !important",
                minWidth: "auto",
                whiteSpace: "nowrap",
                height: "32px",
              }}
              onClick={handleLoginMenuOpen}
            />
            <CustomButton
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  {t("Get App")}
                  <ExpandMoreIcon sx={{ fontSize: 16 }} />
                </Box>
              }
              variant="tertiary"
              size="small"
              sx={{
                fontSize: "12px",
                padding: "6px 10px !important",
                minWidth: "auto",
                whiteSpace: "nowrap",
                height: "32px",
              }}
              onClick={handleGetAppMenuOpen}
            />
            <Button
              onClick={handleLanguageMenuOpen}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
                borderRadius: "4px",
                padding: "6px 10px",
                cursor: "pointer",
                backgroundColor: "#006EC2",
                color: "white",
                textAlign: "center",
                textTransform: "none",
                width: "100%",
                "&:hover": {
                  backgroundColor: "#0058a0",
                  boxShadow: "none",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  marginRight: "4px",
                }}
              >
                {getCurrentLanguage().flag}
              </Typography>
              <Typography
                sx={{
                  color: "#ffffff",
                  fontWeight: 400,
                  fontSize: 12,
                  textAlign: "center",
                  fontFamily: `'Poppins', sans-serif`,
                }}
              >
                {getCurrentLanguage().name}
              </Typography>
              <ExpandMoreIcon sx={{ fontSize: "16px", color: "#ffffff" }} />
            </Button>

            <Menu
              anchorEl={languageMenuAnchor}
              open={Boolean(languageMenuAnchor)}
              onClose={handleLanguageMenuClose}
              sx={{
                "& .MuiPaper-root": {
                  borderRadius: "8px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                  minWidth: "140px",
                }
              }}
            >
              {languageOptions.map((language) => (
                <MenuItem
                  key={language.code}
                  onClick={() => changeLanguage(language.code)}
                  selected={i18n.language === language.code}
                  sx={{
                    py: 1,
                    px: 2,
                    "&:hover": {
                      backgroundColor: "rgba(0, 110, 194, 0.08)",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "rgba(0, 110, 194, 0.12)",
                      "&:hover": {
                        backgroundColor: "rgba(0, 110, 194, 0.16)",
                      }
                    }
                  }}
                >
                  <ListItemIcon sx={{ minWidth: "36px" }}>
                    <Typography sx={{ fontSize: "18px" }}>
                      {language.flag}
                    </Typography>
                  </ListItemIcon>
                  <ListItemText>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontFamily: `'Poppins', sans-serif`,
                        fontWeight: i18n.language === language.code ? 600 : 400,
                      }}
                    >
                      {language.name}
                    </Typography>
                  </ListItemText>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </>
      )}




    </Box>

<Menu
  anchorEl={loginMenuAnchor}
  open={Boolean(loginMenuAnchor)}
  onClose={handleLoginMenuClose}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "center",
  }}
  transformOrigin={{
    vertical: "top",
    horizontal: "center",
  }}
  sx={{
    "& .MuiPaper-root": {
      borderRadius: "8px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
      minWidth: 140,
      border: "1px solid #e0e0e0",
      paddingY: "4px",
    },
  }}
>
  {[
    { label: t("loginRoles.superAdmin"), link: "https://super-admin.biometricpro.app" },
    { label: t("loginRoles.companyAdmin"), link: "https://company-admin.biometricpro.app" },
    { label: t("loginRoles.accountExecutive"), link: "https://account-executive.biometricpro.app" },
    { label: t("loginRoles.worker"), link: "https://employee.biometricpro.app" },
  ].map((item, index) => (
    <MenuItem
      key={index}
      onClick={() => {
        handleLoginMenuClose();
        window.open(item.link, "_blank");
      }}
      sx={{
        py: 0.6,
        "&:hover": { backgroundColor: "rgba(0,110,194,0.08)" },
      }}
    >
      <Typography
        sx={{
          fontSize: "12px",
          fontFamily: "'Poppins', sans-serif",
          color: "#333",
        }}
      >
        {item.label}
      </Typography>
    </MenuItem>
  ))}
</Menu>

<Menu
  anchorEl={getAppMenuAnchor}
  open={Boolean(getAppMenuAnchor)}
  onClose={handleGetAppMenuClose}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "center",
  }}
  transformOrigin={{
    vertical: "top",
    horizontal: "center",
  }}
  sx={{
    "& .MuiPaper-root": {
      borderRadius: "8px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
      border: "1px solid #e0e0e0",
      padding: "8px 4px",
      maxWidth: "calc(100vw - 24px)",
    },
  }}
>
  <Box sx={{ display: "flex", gap: 0.5 }}>
    <Box sx={{ minWidth: 110, flex: "1 1 0" }}>
      <Typography
        sx={{
          fontSize: "11px",
          fontWeight: 600,
          color: "#8a8a8a",
          fontFamily: "'Poppins', sans-serif",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          padding: "4px 8px",
        }}
      >
        {t("Android")}
      </Typography>
      {getAppLinks.android.map((item, index) => (
        <MenuItem
          key={`android-${index}`}
          onClick={() => {
            handleGetAppMenuClose();
            window.open(item.link, "_blank");
          }}
          sx={{
            py: 0.6,
            px: 1,
            whiteSpace: "normal",
            "&:hover": { backgroundColor: "rgba(0,110,194,0.08)" },
          }}
        >
          <Typography
            sx={{
              fontSize: "12px",
              fontFamily: "'Poppins', sans-serif",
              color: "#333",
              lineHeight: 1.3,
              overflowWrap: "break-word",
            }}
          >
            {item.label}
          </Typography>
        </MenuItem>
      ))}
    </Box>
    <Box sx={{ minWidth: 110, flex: "1 1 0", borderLeft: "1px solid #eee" }}>
      <Typography
        sx={{
          fontSize: "11px",
          fontWeight: 600,
          color: "#8a8a8a",
          fontFamily: "'Poppins', sans-serif",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          padding: "4px 8px",
        }}
      >
        {t("iOS")}
      </Typography>
      {getAppLinks.ios.map((item, index) => (
        <MenuItem
          key={`ios-${index}`}
          onClick={() => {
            handleGetAppMenuClose();
            window.open(item.link, "_blank");
          }}
          sx={{
            py: 0.6,
            px: 1,
            whiteSpace: "normal",
            "&:hover": { backgroundColor: "rgba(0,110,194,0.08)" },
          }}
        >
          <Typography
            sx={{
              fontSize: "12px",
              fontFamily: "'Poppins', sans-serif",
              color: "#333",
              lineHeight: 1.3,
              overflowWrap: "break-word",
            }}
          >
            {item.label}
          </Typography>
        </MenuItem>
      ))}
    </Box>
  </Box>
</Menu>

          <Modal
  open={comingSoonOpen}
  onClose={handleCloseComingSoon}
  aria-labelledby="simple-coming-soon-modal"
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  <Box
    sx={{
      backgroundColor: "white",
      borderRadius: "12px",
      boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
      width: "90%",
      maxWidth: 400,
      p: 4,
      textAlign: "center",
      position: "relative",
    }}
  >
    <IconButton
      onClick={handleCloseComingSoon}
      sx={{
        position: "absolute",
        top: 8,
        right: 8,
        color: "#666",
        "&:hover": { backgroundColor: "#f2f2f2" },
      }}
    >
      <CloseIcon />
    </IconButton>

    <Typography
      sx={{
        fontSize: "24px",
        fontWeight: 700,
        color: "#003149",
        fontFamily: "Poppins, sans-serif",
        marginBottom: "8px",
      }}
    >
      {t("common.comingSoon")}
    </Typography>

    <Typography
      sx={{
        fontSize: "16px",
        color: "#666",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      {t("This feature is coming soon!")}
    </Typography>
  </Box>
</Modal>
</>
  );
};

export default Header;